import { IError } from 'ui/interfaces/entities/apiError';
import { IMetaData } from 'patientCommons/interfaces/entities/patient/detail';
import axios from 'ui/utils/axios';

export namespace GET {
  export const getUrl = () => `/patients/personal_information/_meta`;

  export const service = () =>
    axios.post<IResponse>(getUrl(), {
      categories: [
        'address_types',
        'languages',
        'functional_limitations',
        'modes_of_contact',
        'preferred_time_days',
        'phone_number_types',
        'states',
        'family_member_relations',
        'caregiver_relations',
        'related_members_relations',
        'relation_types',
      ],
    });

  export type IResponse = IMetaData;
  export type IResponseError = IError;
}
